/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-restricted-imports */
/* eslint-disable react-hooks/static-components */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Headline, Text, TextLink } from '@oneaudi/unified-web-components';
import { UeElement } from '@oneaudi/falcon-tools';
import { renderTextWithFootnotesReferencesV2 } from '@oneaudi/feature-app-utils';
import { TextBlock, TitleTextBlock, CTAContainer } from './style';
import type { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import { trackClick } from '../../utilTrackingHelpers/click';

interface TextBlockProps {
  ctaLink: string;
  ctaText: string;
  title: string;
  bodyText: string;
  openIn: string;
  width?: number | undefined;
  ariaLabel?: string;
  trackingService: TrackingServiceV2;
  slideIndex: number;
  isCurrent: number;
}
interface TitleComponentProps {
  children: React.ReactNode;
  [key: string]: any; // or be more specific with prop types if possible
}

export const FeatureGalleryTextBlock: React.FC<TextBlockProps> = (props) => {
  const {
    bodyText,
    ctaLink,
    ctaText,
    title,
    openIn,
    ariaLabel,
    width,
    trackingService,
    isCurrent,
    slideIndex,
    ...ueProps
  } = props;
  const isAlpha = !process.env.IS_LEGACY;
  function setCtaUrl(link: string) {
    console.log('🚀 ~ setCtaUrl ~ link:', link);
    if (!link) return undefined;

    if (!(link.indexOf('/') === 0)) {
      return link;
    }
    // Check if we're in a browser environment (not SSR)
    const isBrowser =
      typeof window !== 'undefined' &&
      typeof window.location !== 'undefined' &&
      typeof window.location.origin !== 'undefined';

    if (!isBrowser) {
      return undefined;
    }
    return window.location.origin + link;
  }

  const TitleComponent = ({ children, ...props }: TitleComponentProps) => {
    if (isAlpha) {
      return (
        <Headline
          className="alpha-title"
          tag="span"
          variant={{ type: 'headline', order: '3', weight: 'normal' }}
          {...props}
        >
          {children}
        </Headline>
      );
    }

    return (
      <Text
        className="legacy-title"
        variant={{ type: 'copy', order: '1', style: 'bold' }}
        {...props}
      >
        {children}
      </Text>
    );
  };

  return (
    <span {...ueProps}>
      <TextBlock className="fg-text-block-content" isAlpha={isAlpha}>
        <TitleTextBlock width={width} isAlpha={isAlpha}>
          <TitleComponent {...ueProps} isAlpha={isAlpha}>
            <UeElement type="text" property="title" label="Title">
              {renderTextWithFootnotesReferencesV2(title)}
            </UeElement>
          </TitleComponent>
          <Text tag="p" variant={{ type: 'copy', order: '1', style: 'normal' }} {...ueProps}>
            <UeElement type="text" property="bodyText" label="Body text">
              {renderTextWithFootnotesReferencesV2(bodyText)}
            </UeElement>
          </Text>
        </TitleTextBlock>
        {ctaText ? (
          <CTAContainer>
            <TextLink
              variant="standalone"
              target={openIn === 'Same tab' ? '_self' : '_blank'}
              href={setCtaUrl(ctaLink) as string}
              aria-label={ariaLabel}
              onClick={() => {
                const eventObj = {
                  targetURL: setCtaUrl(ctaLink),
                  eventAction: trackingService.evaluateLinkType(ctaLink) as string,
                  eventName: 'feature gallery - click on link',
                  elementName: 'text link',
                  value: '',
                  pos: `${isCurrent + 1}`,
                  actionType: 'click',
                  label: ctaText,
                };
                trackClick(trackingService, eventObj);
              }}
              size={isAlpha ? 'sm' : 'md'}
              iconPosition="trailing"
              icon="forward"
            >
              <UeElement type="text" property="cta1_ctaText1" label="CTA text">
                {ctaText}
              </UeElement>
            </TextLink>
          </CTAContainer>
        ) : null}
      </TextBlock>
    </span>
  );
};
